module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAACCAYAAAAuPE4AAAAAHklEQVQYlWOUf/T/PwN+wIgmOyDqmQhYOjgAAwMDALpSBgN/fZnoAAAAAElFTkSuQmCC"